import { camelCaseToKebabCase } from 'Js/utils/stringUtils.js';
/**
 * Defines a logic for building ids for elements
 */
export function useIdBuilder() {
    /**
     * Calculates an id for the element based on one or many provided property names (keys)
     * @param prefix
     * @param keys
     */
    function buildId(prefix, keys) {
        if (!keys) {
            return prefix;
        }
        const key = (keys instanceof Array) ? keys.map(key => camelCaseToKebabCase(key)).join('-') : camelCaseToKebabCase(keys);
        return `${prefix}-${key}`;
    }
    /**
     * Calculates an id for the element, base on the values of the provided item
     * @param prefix
     * @param keys
     * @param item
     */
    function buildIdForItem(prefix, keys, item) {
        if (keys instanceof Array) {
            let id = '';
            keys.forEach(key => id += `-${item[key]}`);
            return `${prefix}-${id}`;
        }
        return `${prefix}-${item[keys]}`;
    }
    return {
        buildId,
        buildIdForItem
    };
}
